// extracted by mini-css-extract-plugin
module.exports = {"content-container":"_25cTVy"};